import { REMOVE_TRANSLATIONS, REPLACE_TRANSLATIONS, SET_TRANSLATIONS } from './types'

const polyglot = (state = {
  phrases: {},
  hasTranslations: false,
  locale: null
}, action) => {
  switch (action.type) {
    case (SET_TRANSLATIONS) :
      return {
        hasTranslations: true,
        phrases: action.payload.phrases,
        locale: action.payload.locale
      }
    case (REPLACE_TRANSLATIONS) :
      return {
        hasTranslations: true,
        phrases: action.payload.phrases,
        locale: action.payload.locale
      }
    case (REMOVE_TRANSLATIONS) :
      return {
        hasTranslations: false,
        phrases: {},
        locale: null
      }
    default:
      return state
  }
}

export default polyglot
